// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import AppBar from "@mui/material/AppBar";
import Logo from "../assets/img/WSO2-Logo-Black.png";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import { Container } from "@mui/system";
import MenuPopper from "./landing-page/MenuPopper";

import { RootState, useAppSelector } from "../slices/store";
import { NavLink, NavLinkProps } from "react-router-dom";
import { RefAttributes } from "react";
import { routes } from "../config/constant";

export const LoginAppBar = () => {
  const auth = useAppSelector((state: RootState) => state.auth);

  function ActiveLink(
    props: JSX.IntrinsicAttributes &
      NavLinkProps &
      RefAttributes<HTMLAnchorElement>
  ) {
    return (
      <NavLink
        style={({ isActive }) => ({
          color: isActive ? "#FF7300" : "#212A32",
          textDecoration: "none",
          fontSize: "14px",
          marginLeft: "10px",
          marginRight: "10px",
        })}
        {...props}
        end
      />
    );
  }

  return (
    <AppBar position="fixed" color="inherit" elevation={2}>
      <Container disableGutters>
        <Toolbar>
          <img
            src={Logo}
            alt="Logo"
            style={{ width: "120px", marginLeft: "-24px" }}
          />

          <Typography
            variant="h6"
            color="inherit"
            sx={{ flexGrow: 1 }}
            align="left"
          >
            {/* Certification Portal */}
          </Typography>

          {auth.isAuthenticated ? (
            <nav>
              <>
                <ActiveLink to={routes.home}>HOME</ActiveLink>

                <ActiveLink to={routes.exams}>MY EXAMS</ActiveLink>

                <ActiveLink to={routes.certifications}>
                  MY CERTIFICATIONS
                </ActiveLink>
              </>
            </nav>
          ) : null}

          <MenuPopper />
        </Toolbar>
      </Container>
    </AppBar>
  );
};
